var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-var */
import { isEmpty } from "lodash";
import { useCallback, useContext, useEffect, useState } from "react";
import { TMOScripList, addToBasket, allowTMOOptionScrip, createSmoOrderRequest, modifyOrderInBasket, modifySmoOrderRequest, } from "src/apis/dashboard";
// import { getAllowTmoDummyScriptData } from "src/apis/mock/data/get-allow-tmo-script";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_VERSION, REACT_APP_ENV } = process.env;
import StepNumberInput from "src/components/inputs/step-number-input";
import { useAppDispatch } from "src/hooks/redux";
import styles from "src/pages/dashboard/forms/buyforms/buyform.module.scss";
import { refreshNetPosition } from "src/redux/reducers/common-reducer";
import { openAddToBasketModal } from "src/redux/reducers/modals";
import { captureAddToBasket, captureBuySellAnalytics, captureCleverTabAnalytics, } from "src/utils/analytics";
import { CURRENCY_DECIMAL_LENGTH_LIMIT, DECIMAL_LENGTH_LIMIT, } from "src/utils/constant";
import { generateRandomRemoteId, getExchFromDisplayText, getOrderValidityFromDayType, handleDecimalLimit, splitAndGetDetailsFromLongName, } from "src/utils/methods";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import useOrderRequestHook from "../useOrderRequestHook";
import CoverBracketOrderForm from "./cover-bracket-order";
import moment from "moment";
import { PricePickerContext } from "src/contexts/custom-context";
const componentName = "RegularStopLossBuyForm";
const IntraDayRegularBuyForm = ({ scripData, lotSize, scripPriceData, formType, returnValue, execute, executeCallback, afterMarketHours, validityDate, dayType, disclosedQuantity, isFormValid, isLoading: isLoadingBuyform, sliceLimitData, toggleSliceConsent, fetchSetting, isBuyForm, }) => {
    const dispatch = useAppDispatch();
    const [modifyOrderType, setModifyOrderType] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [allowBktOrder, setAllowBktOrder] = useState(undefined);
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const setLoadingCallback = (newValue) => {
        setLoading(newValue);
    };
    const [priceType, setPriceType] = useState("market");
    const [price, setPrice] = useState("0");
    const [priceErrorMessage, setPriceErrorMessage] = useState("");
    const [stockQuantity, setStockQuantity] = useState(0);
    const [coverBracketFormValid, setCoverBracketFormValid] = useState(true);
    const [stockQtyErrorMessage, setStockQtyErrorMessage] = useState("");
    const [coverBracketFormData, setCoverBracketFormData] = useState();
    const { getRequestOrderReqJson, sendOrderRequest, executeOrder } = useOrderRequestHook({
        afterMarketHours,
        clientCode,
        validityDate,
        dayType,
        disclosedQuantity,
        formType,
        price,
        priceType,
        productType: "intraday",
        scripData,
        stockQuantity,
        stopLossTriggerPrice: coverBracketFormData
            ? coverBracketFormData.stopLossTriggerPrice
            : "",
        timeType: "regular",
        lotSize,
        sliceLimitData,
        executeCallback,
        toggleSliceConsent,
        setLoading: setLoadingCallback,
        bulkModifyArray: scripData === null || scripData === void 0 ? void 0 : scripData.bulkModifyArray,
    });
    const { picker, setPicker } = useContext(PricePickerContext);
    useEffect(() => {
        onPriceChange(picker.price + "");
        setPriceType(picker.type);
    }, [picker.price]);
    const setStockQuantityCallback = useCallback((newValue, isInput = false) => {
        if (newValue != stockQuantity && newValue > 0) {
            if (fetchSetting.qty && !isInput) {
                const newQuantity = fetchSetting.key == "fno"
                    ? fetchSetting.qty * lotSize
                    : fetchSetting.qty;
                if (newQuantity !== stockQuantity) {
                    setStockQuantity(newQuantity);
                }
            }
            else {
                setStockQuantity(newValue);
            }
        }
    }, [fetchSetting.qty, lotSize]);
    const onAddToBasket = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const priceInPaisa = Math.round(parseFloat(price) * (scripData.exchangeType == "U" ? 10000000 : 100));
        if (!isEmpty(validityDate)) {
            validityDate = validityDate
                .replace("/Date(", "")
                .replace(")/", "")
                .split("+")[0];
        }
        const validity = dayType == "vtd" && !isEmpty(validityDate)
            ? new Date(Number(validityDate))
            : new Date();
        validity.setHours(23);
        validity.setMinutes(59);
        validity.setSeconds(59);
        validity.setMilliseconds(999);
        const nameBreakup = splitAndGetDetailsFromLongName(scripData.name);
        const tempValidityDate = `/Date(${moment(validity.getTime()).format("X") + "+0530"})/`;
        const payload = {
            name: scripData.name,
            Exchange: getExchFromDisplayText(scripPriceData.exchange),
            ExchangeType: scripPriceData.exchangeType,
            ScripCode: scripData.scripCode,
            Price: priceInPaisa,
            OrderType: formType,
            Qty: stockQuantity,
            AtMarket: priceType == "market" ? true : false,
            StopLossPrice: parseFloat((coverBracketFormData === null || coverBracketFormData === void 0 ? void 0 : coverBracketFormData.stopLossTriggerPrice)
                ? coverBracketFormData === null || coverBracketFormData === void 0 ? void 0 : coverBracketFormData.stopLossTriggerPrice
                : "0") * (scripData.exchangeType == "U" ? 10000000 : 100),
            IsStopLossOrder: false,
            IOCOrder: dayType == "ioc",
            DelvIntra: "I",
            IsIntraday: true,
            AHPlaced: "N",
            PublicIP: "0.0.0.0",
            DisQty: disclosedQuantity,
            iOrderValidity: getOrderValidityFromDayType(dayType),
            AppSource: "21",
            orderFor: scripData.orderFor,
        };
        if (nameBreakup.expiry && nameBreakup.expiry.length > 0) {
            const tempExpiry = `/Date(${moment(nameBreakup.expiry).set("hour", 14).set("minute", 30).valueOf() +
                "+0530"})/`;
            payload.ExpiryDate = tempExpiry;
            payload.StrikeRate = nameBreakup.strikeRate ? nameBreakup.strikeRate : 0;
        }
        // OTHER THAN OPTION , SEND XX FOR ALL
        // LATEST CHANGE - BACKEND DONT NEED CP TYPE FOR MODIFY OPTION
        payload.CPType = "XX";
        try {
            setLoadingCallback(true);
            if (scripData.orderFor == "M" && scripData.orderData) {
                const body = Object.assign(Object.assign({}, payload), { ValidTillDate: tempValidityDate, OrderID: ((_a = scripData.orderData) === null || _a === void 0 ? void 0 : _a.OrderID)
                        ? scripData.orderData.OrderID
                        : 0 });
                const resp = yield modifyOrderInBasket(body);
                const message = resp.data.body.Message;
                if (resp == null || resp.data.body.Status != 0) {
                    captureAddToBasket(false, payload.name);
                    executeCallback(false, message);
                }
                else {
                    executeCallback(true, "Order modified successfully.");
                }
            }
            else if (scripData.basketIds) {
                const body = Object.assign(Object.assign({}, payload), { BasketIDs: scripData.basketIds, ValidTillDate: validity.getTime() + "" });
                const resp = yield addToBasket(body);
                const addOrderToBasketResData = resp.data.body.AddOrderToBasketResData;
                const message = resp.data.body.Message;
                if (addOrderToBasketResData == null) {
                    executeCallback(false, message);
                }
                else {
                    captureAddToBasket(true, payload.name);
                    // if (window.dataLayer) {
                    //   window.dataLayer.push({
                    //     event: "FNO360",
                    //     eventCategory: "FNO360",
                    //     eventAction: `Add to basket - FNO`,
                    //     eventLabel: `${payload.name} - ${payload.IsIntraday} - ${
                    //       payload.Qty
                    //     } - ${payload.Price / 100}`,
                    //   });
                    // }
                    executeCallback(true, "Added to Basket" + (scripData.basketIds.length > 1 ? "s." : "."));
                }
            }
            else {
                dispatch(openAddToBasketModal(payload));
                executeCallback(false);
            }
        }
        catch (error) {
            captureAddToBasket(false, payload.name);
            console.error(error);
        }
        finally {
            setLoadingCallback(false);
            executeCallback(false);
        }
    });
    const modifySMOOrderCallBack = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        try {
            if (!scripData.orderData) {
                return;
            }
            if (!coverBracketFormData) {
                return;
            }
            let targetPriceLocal = 0;
            let orderId = 0;
            let traillingSL = parseFloat(coverBracketFormData.tralingStopLoss);
            let stopLoss = parseFloat(coverBracketFormData.stopLossTriggerPrice);
            // if (
            //   modifyOrderType == "STOPLOSS" &&
            //   scripData.orderData.DelvIntra == "C"
            // ) {
            //   if (parseFloat(coverBracketFormData.tralingStopLoss) > 0) {
            //     traillingSL = parseFloat(coverBracketFormData.tralingStopLoss) * 100;
            //   }
            // } else
            if (modifyOrderType == "STOPLOSS") {
                orderId = 1;
                if (parseFloat(coverBracketFormData.tralingStopLoss) > 0) {
                    traillingSL = parseFloat(coverBracketFormData.tralingStopLoss) * 100;
                }
                targetPriceLocal = parseFloat(coverBracketFormData.stopLossPrice);
            }
            else if (modifyOrderType == "PROFIT") {
                orderId = 2;
                stopLoss = 0.0;
                targetPriceLocal = parseFloat(coverBracketFormData.targetPrice);
            }
            setLoadingCallback(true);
            const response = yield modifySmoOrderRequest(orderId, scripData.orderData.ExchOrderID, clientCode, scripData.exchange, scripData.exchangeType, scripData.scripCode, targetPriceLocal == 0, targetPriceLocal, (_b = scripData.orderData) === null || _b === void 0 ? void 0 : _b.PendingQty, disclosedQuantity, afterMarketHours, 
            // scripData.orderData?.DelvIntra,
            formType == "BUY" ? "B" : "S", traillingSL, stopLoss, modifyOrderType == "STOPLOSS");
            if (response.data.body.RMSStatus == 0 || response.data.body.Status == 0) {
                executeCallback(true, "Order modified successfully");
            }
            else {
                executeCallback(false, response.data.body.Message);
            }
        }
        catch (err) {
            console.error(err);
            // executeCallback(false, "Something went wrong");
        }
        finally {
            setLoadingCallback(false);
            executeCallback(false);
            dispatch(refreshNetPosition(true));
        }
    });
    const createSMOOrderCallBack = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        if (modifyOrderType == "STOPLOSS" || modifyOrderType == "PROFIT") {
            return modifySMOOrderCallBack();
        }
        if (!coverBracketFormData) {
            return;
        }
        try {
            setLoadingCallback(true);
            const response = yield createSmoOrderRequest(clientCode, scripData.exchange, scripData.exchangeType, scripData.scripCode, formType, priceType == "market", priceType == "market" ? 0 : parseFloat(price), stockQuantity, ((_c = scripData.orderData) === null || _c === void 0 ? void 0 : _c.ExchOrderID) ? (_d = scripData.orderData) === null || _d === void 0 ? void 0 : _d.ExchOrderID : 1, disclosedQuantity, parseFloat(coverBracketFormData.stopLossPrice), afterMarketHours, scripData.orderFor || "", parseFloat(coverBracketFormData.targetPrice) == 0 ? "C" : "S", parseFloat(coverBracketFormData.targetPrice), parseFloat(coverBracketFormData.stopLossTriggerPrice), parseFloat(coverBracketFormData.tralingStopLoss) * 100);
            if (response.data.body.RMSStatus == 0 || response.data.body.Status == 0) {
                captureBuySellAnalytics(true, formType, scripData.name);
                // if (window.dataLayer) {
                //   window.dataLayer.push({
                //     event: "FNO360",
                //     eventCategory: "FNO360",
                //     eventAction: `${formType} FNO Stock`,
                //     eventLabel: `${scripData.name} - true - ${stockQuantity} - ${price}`,
                //   });
                // }
                captureCleverTabAnalytics("Order request placed successfully", {
                    "Initiate source": "",
                    AHPLACED: afterMarketHours,
                    ATMARKET: priceType == "market",
                    DISQTY: disclosedQuantity,
                    Exchange: scripData.exchange,
                    ExchangeType: scripData.exchangeType,
                    IOCOrder: false,
                    IsIntraday: true,
                    IsStopLossOrder: true,
                    IsVTD: false,
                    OrderDateTime: new Date().getTime(),
                    OrderFor: scripData.orderFor || "",
                    OrderID: 4,
                    OrderType: formType,
                    Price: price,
                    PublicIP: "",
                    Qty: stockQuantity,
                    RemoteOrderID: generateRandomRemoteId(),
                    ScripCode: scripData.scripCode,
                    StopLossPrice: coverBracketFormData.stopLossTriggerPrice,
                    TradedQty: scripData.orderData ? scripData.orderData.TradedQty : 0,
                    "CT Web Version": REACT_APP_VERSION,
                    "CT Source": "Derivative360",
                    OrderForm: parseFloat(coverBracketFormData.targetPrice) == 0 ? "C" : "S",
                });
                // if (window.clevertap) {
                //   window.clevertap.event.push("Order request placed successfully", {
                //     "Initiate source": "",
                //     AHPLACED: afterMarketHours,
                //     ATMARKET: priceType == "market",
                //     DISQTY: disclosedQuantity,
                //     Exchange: scripData.exchange,
                //     ExchangeType: scripData.exchangeType,
                //     IOCOrder: false,
                //     IsIntraday: true,
                //     IsStopLossOrder: true,
                //     IsVTD: false,
                //     OrderDateTime: new Date().getTime(),
                //     OrderFor: scripData.orderFor || "",
                //     OrderID: 4,
                //     OrderType: formType,
                //     Price: price,
                //     PublicIP: "",
                //     Qty: stockQuantity,
                //     RemoteOrderID: "202205270455305",
                //     ScripCode: scripData.scripCode,
                //     StopLossPrice: coverBracketFormData.stopLossTriggerPrice,
                //     TradedQty: scripData.orderData ? scripData.orderData.TradedQty : 0,
                //     "CT Web Version": REACT_APP_VERSION,
                //     "CT Source": "Derivative360",
                //     OrderForm:
                //       parseFloat(coverBracketFormData.targetPrice) == 0 ? "C" : "S",
                //   });
                // }
                executeCallback(true, scripData.orderFor == "P"
                    ? "Order placed successfully"
                    : "Order modified successfully");
                dispatch(refreshNetPosition(true));
            }
            else {
                captureBuySellAnalytics(false, `${formType}`, scripData.name);
                executeCallback(false, response.data.body.Message);
            }
        }
        catch (err) {
            captureBuySellAnalytics(false, formType, scripData.name);
            //console.error(err);
            // executeCallback(false, "Something went wrong");
        }
        finally {
            setLoadingCallback(false);
            executeCallback(false);
        }
    });
    const sendOrderRequestWrapper = () => {
        var _a, _b;
        if ((_b = (_a = scripData === null || scripData === void 0 ? void 0 : scripData.bulkModifyArray) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 > 0) {
            executeOrder(getRequestOrderReqJson());
        }
        else {
            if (allowBktOrder &&
                coverBracketFormData &&
                coverBracketFormData.addStoplossExpand) {
                return createSMOOrderCallBack();
            }
            sendOrderRequest(getRequestOrderReqJson());
        }
    };
    useEffect(() => {
        setStockQuantityCallback(fetchSetting.qty);
    }, [scripData]);
    useEffect(() => {
        if (stockQuantity <= 0) {
            setStockQuantityCallback(scripData.exchange == "M" ? 1 : lotSize);
        }
    }, [lotSize, stockQuantity]);
    // useEffect(() => {
    //   // console.log(fetchSetting.priceType);
    //   onPriceTypeChange(fetchSetting.priceType);
    //   // setPriceType();
    // }, [fetchSetting]);
    useEffect(() => {
        if (scripData.orderData || scripData.netPositionDetail) {
        }
        else {
            setStockQuantityCallback(scripData.exchange == "M" ? 1 : lotSize);
        }
    }, [scripData, lotSize]);
    //================================Quantity and above close=======================
    const onPriceChange = (priceValue) => {
        setPrice(scripPriceData.exchangeType == "U"
            ? handleDecimalLimit(priceValue, CURRENCY_DECIMAL_LENGTH_LIMIT)
            : handleDecimalLimit(priceValue, DECIMAL_LENGTH_LIMIT));
    };
    useEffect(() => {
        if (priceType == "limit") {
            setPrice((scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.exchangeType) == "U"
                ? handleDecimalLimit((scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.lastTradePrice) + "", CURRENCY_DECIMAL_LENGTH_LIMIT)
                : handleDecimalLimit((scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.lastTradePrice) + "", DECIMAL_LENGTH_LIMIT));
        }
    }, [scripData === null || scripData === void 0 ? void 0 : scripData.lastTradePrice]);
    const onPriceTypeChange = (type) => {
        var _a;
        if (modifyOrderType == "STOPLOSS" || modifyOrderType == "PROFIT") {
            return;
        }
        if (priceType != type) {
            setPriceType(type);
            if (type == "limit") {
                onPriceChange(scripPriceData.lastTradePrice
                    ? scripPriceData.lastTradePrice + ""
                    : ((_a = scripData.orderData) === null || _a === void 0 ? void 0 : _a.Rate) + "");
            }
            else {
                onPriceChange("0");
            }
        }
    };
    const [showChart, setShowChart] = useState(false);
    const onEditMarketChange = () => {
        setShowChart(!showChart);
    };
    useEffect(() => {
        returnValue(getRequestOrderReqJson());
        isFormValid(isFormValidCallback());
    }, [
        price,
        stockQuantity,
        stockQtyErrorMessage,
        priceErrorMessage,
        isLoading,
        modifyOrderType,
        coverBracketFormValid,
    ]);
    useEffect(() => {
        if (execute) {
            if (scripData.isBasket) {
                onAddToBasket();
            }
            else {
                sendOrderRequestWrapper();
            }
        }
    }, [execute]);
    const isStopLossPanelVisible = () => {
        if (allowBktOrder) {
            if (scripData.isBasket) {
                return false;
            }
            else if (scripData.orderFor == "M") {
                if (modifyOrderType == "REGULAR") {
                    return false;
                }
                else {
                    return true;
                }
            }
            else if (scripData.exchange == "M") {
                return false;
            }
            else if (scripData.exchangeType == "U") {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    };
    const isFormValidCallback = useCallback(() => {
        if (isLoading) {
            return false;
        }
        else if (stockQtyErrorMessage != "") {
            return false;
        }
        else if (priceErrorMessage != "") {
            return false;
        }
        else if (isStopLossPanelVisible()) {
            return coverBracketFormValid;
        }
        else {
            return true;
        }
    }, [
        isLoading,
        priceErrorMessage,
        coverBracketFormValid,
        stockQtyErrorMessage,
    ]);
    useEffect(() => {
        if (priceType == "limit") {
            if (modifyOrderType == "STOPLOSS" || modifyOrderType == "PROFIT") {
                setPriceErrorMessage("");
            }
            else if (isEmpty(price)) {
                setPriceErrorMessage("Price is compulsory.");
            }
            else if (parseFloat(price) <= 0) {
                setPriceErrorMessage("Price cannot be zero or negative.");
            }
            else {
                setPriceErrorMessage("");
            }
        }
        else {
            setPriceErrorMessage("");
        }
    }, [price, priceType]);
    //modify useeffect
    useEffect(() => {
        // console.log(JSON.stringify(scripData));
        if (scripData.netPositionDetail) {
            setStockQuantityCallback(scripData.netPositionDetail.NetQty);
        }
        if (scripData.orderData) {
            setStockQuantityCallback(scripData.orderData.Qty);
            // if (scripData.orderData.AtMarket == "N") {
            //   onPriceTypeChange("limit");
            //   onPriceChange(scripData.orderData.Rate + "");
            // } else {
            //   onPriceTypeChange("market");
            // }
            const DelvIntra = scripData.orderData.DelvIntra;
            // if (DelvIntra == "I" || DelvIntra == "S" || DelvIntra == "C") {
            // if (allowBktOrder) {
            if (DelvIntra == "S" || DelvIntra == "C") {
                if (scripData.orderFor == "M") {
                    if (DelvIntra == "S") {
                        if (scripData.orderData.SMOProfitRate != 0 &&
                            scripData.orderData.SMOSLTriggerRate != 0) {
                            setModifyOrderType("");
                            // return Constants.ORDERTYPE.BRACKET_INITIAL;
                        }
                        else if (scripData.orderData.WithSL == "Y") {
                            setModifyOrderType("STOPLOSS");
                            onPriceTypeChange("market");
                            // return Constants.ORDERTYPE.BRACKET_SL;
                        }
                        else if (scripData.orderData.WithSL == "N") {
                            setModifyOrderType("PROFIT");
                            onPriceTypeChange("market");
                            // return Constants.ORDERTYPE.BRACKET_PROFIT;
                        }
                    }
                    else if (DelvIntra == "C") {
                        if (scripData.orderData.SMOSLTriggerRate != 0) {
                            setModifyOrderType("");
                            // return Constants.ORDERTYPE.COVER_INITIAL;
                        }
                        else if (scripData.orderData.WithSL == "Y") {
                            setModifyOrderType("STOPLOSS");
                            onPriceTypeChange("market");
                            // return Constants.ORDERTYPE.COVER_SL;
                        }
                    }
                    else {
                        setModifyOrderType("REGULAR");
                    }
                }
            }
            // } else {
            //   setModifyOrderType("");
            //   setCoverBracketFormData(undefined);
            // }
            // }
        }
        // getSliceLimitCallback();
    }, [scripData]);
    useEffect(() => {
        // console.log("scripData.scripCode", scripData.scripCode);
        if (scripData.orderFor == "P") {
            validateCoBktOrder(scripData.exchange, scripData.exchangeType, scripData.scripCode);
        }
        else {
            setAllowBktOrder(true);
        }
    }, [scripData.scripCode]);
    const validateCoBktOrder = (exch, exchType, code) => __awaiter(void 0, void 0, void 0, function* () {
        if (scripData.exchangeType == "C") {
            getTMOList(exch, exchType, code);
        }
        else {
            allowOptionScript(exch, exchType, code);
        }
    });
    const allowOptionScript = (exch, exchType, code) => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        try {
            const fetchScripResponse = yield allowTMOOptionScrip(exch, exchType, code);
            // const fetchScripResponse = await { data: getAllowTmoDummyScriptData() };
            if (((_e = fetchScripResponse === null || fetchScripResponse === void 0 ? void 0 : fetchScripResponse.data.body) === null || _e === void 0 ? void 0 : _e.status) == 1) {
                setAllowBktOrder(false);
            }
            else {
                setAllowBktOrder(true);
            }
        }
        catch (error) {
            setAllowBktOrder(false);
        }
    });
    const getTMOList = (exch, exchType, code) => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g, _h;
        try {
            const fetchScripResponse = yield TMOScripList(exch, exchType);
            //const fetchScripResponse = await { data: TMOScripList() };
            if (((_f = fetchScripResponse.data.body) === null || _f === void 0 ? void 0 : _f.TMOScripList) &&
                ((_g = fetchScripResponse.data.body) === null || _g === void 0 ? void 0 : _g.TMOScripList.length) > 0) {
                const scriptFound = (_h = fetchScripResponse.data.body) === null || _h === void 0 ? void 0 : _h.TMOScripList.filter((item) => item.ScripCode == code);
                //console.log(scriptFound, "scriptFound");
                setAllowBktOrder(scriptFound.length > 0 ? true : false);
            }
            else {
                setAllowBktOrder(true);
            }
        }
        catch (error) {
            setAllowBktOrder(false);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.priceInputWrapper} d-flex justify-content-between align-items-end` }, { children: [_jsx("div", Object.assign({ className: `${styles.stepInputBuyform}` }, { children: _jsx(StepNumberInput, { inputLabel: scripData.exchange == "M"
                                ? `Quantity (1 Lot = ${lotSize})`
                                : "Quantity", isFocus: true, formType: formType, defaultValue: stockQuantity, placeholder: false, stepInput: scripData.exchange == "M" ? 1 : lotSize, errorMessage: "Invalid Quantity", allowZero: false, showError: false, errorMessageCallback: (errMsg) => {
                                setStockQtyErrorMessage(errMsg);
                            }, returnValue: (data) => {
                                setStockQuantityCallback(data, true);
                            }, disabled: 
                            // scripData?.bulkModifyArray?.length ?? 0 > 1
                            //   ? true
                            //   : modifyOrderType == "STOPLOSS" ||
                            //     modifyOrderType == "PROFIT" ||
                            //     isLoadingBuyform
                            false, isBuyForm: isBuyForm }) })), _jsxs("div", Object.assign({ className: `${styles.priceInput}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center h-15" }, { children: [_jsx("label", { children: "Price" }), _jsxs("div", Object.assign({ className: `${styles.marketLimit}` }, { children: [_jsx("span", Object.assign({ className: priceType == "market" ? styles.active : "", onClick: () => {
                                                    onPriceTypeChange("market");
                                                    const inputElement = document.querySelector(".disabled-input");
                                                    inputElement.style.pointerEvents = "none";
                                                } }, { children: "Market" })), _jsx("span", Object.assign({ className: priceType == "limit" ? styles.active : "", onClick: () => onPriceTypeChange("limit") }, { children: "Limit" }))] }))] })), _jsx("div", Object.assign({ className: "input-group mt-2", onClick: () => {
                                    onPriceTypeChange("limit");
                                    const inputElement = document.querySelector(".disabled-input");
                                    inputElement.style.pointerEvents = "auto";
                                } }, { children: _jsx("input", { type: "number", placeholder: "Market Price", className: `${styles.formControl} ${priceErrorMessage && styles.inputError} form-control disabled-input`, "aria-label": "", onWheel: (event) => {
                                        event.target.blur();
                                    }, disabled: priceType == "market" ||
                                        modifyOrderType == "STOPLOSS" ||
                                        modifyOrderType == "PROFIT", value: price + "", step: scripPriceData.exchangeType == "U" ? "0.0001" : "0.01", onChange: (event) => onPriceChange(event.target.value), style: { pointerEvents: "none" } }) }))] }))] })), _jsxs("div", Object.assign({ className: `${styles.errorWrapper} d-flex justify-content-between mt-1` }, { children: [_jsxs("p", Object.assign({ className: `${styles.errorText} ${styles.errorTextLeft}` }, { children: [stockQtyErrorMessage && _jsx("span", { className: "errorIcon me-1" }), stockQtyErrorMessage] })), _jsxs("p", Object.assign({ className: `${styles.errorText} ${styles.errorTextRight}`, hidden: priceErrorMessage == "" }, { children: [priceErrorMessage && _jsx("span", { className: "errorIcon me-1" }), priceErrorMessage] }))] })), isStopLossPanelVisible() && (_jsx(CoverBracketOrderForm, { modifyOrderType: modifyOrderType, scripData: scripData, isFormValid: (newValue) => {
                    setCoverBracketFormValid(newValue);
                }, setCoverBracketFormData: (newValue) => {
                    setCoverBracketFormData(newValue);
                }, formType: formType, priceType: priceType, price: price, fetchSetting: fetchSetting }))] }));
};
export default IntraDayRegularBuyForm;
